
	import VueAMap from 'vue-amap'
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import { Loading } from 'element-ui';
	import fa from "element-ui/src/locale/lang/fa";
	import markr from "@/assets/bjba/map/mark_r.png";
	import Calendar from 'vue-calendar-component';
	import da from "element-ui/src/locale/lang/da";
	@Component({
		name: 'map',
		components: {
			Calendar
		}
	})
	export default class map extends Vue {
		form={
			name:'',
			username:''
		}
		total= 0
		userCurrentPage=1
		userList=[]
		loading=false
		labelPosition = "right"
		centerDialogVisible = false
		amapManager = new VueAMap.AMapManager()
		userid=''
		arr=[]
		polyline= {
			path: [],
			events: {
				click(e) {

				},
				end: (e) => {
					let newPath = e.target.getPath().map(point => [point.lng, point.lat]);
					console.log(newPath);
				}
			},
			editable: false
		}
		zoom={
			zoom: 12
		}
		events = {
			zoomchange: (e :any) => {
				var _that = this;
				console.log(_that.$refs.map.$$getInstance().getZoom())
				_that.zoom.zoom=_that.$refs.map.$$getInstance().getZoom()

			}
		}
		window={
			position:[121.506377, 31.245105],
			visible: false,
			info: {}
		}
		center = [121.506377, 31.245105]
		markers = []
		markers2 = []
		circles = []
		user={}
		bm={}
		gd=[]
		month=''
		year=''
		datetime = this.getNowFormatDate()
		searchOption = {
			city: '上海',
			citylimit: true
		}
		mapCenter = []
		dialogFormVisible = false
		formLabelWidth = '80px'

		tableData = []
		onjobList = []
		vacatList = []
		leaveList = []
		neglectList = []
		table_search=''
		dkgdmc = ''
		mounted() {
			var userid =this.$route.query.id
			this.init(userid)
		}
		goBack() {
			this.$router.go(-1)
		}
		selectUser(row) {
			this.userid = row.id
			this.polyline.path = []
			this.getUserInfo()
			this.getData()
			this.getHasLocationsDay()
		}
		init (id) {
			this.userid = id
			this.datetime = this.getNowFormatDate()
			this.polyline.path = []
			this.getData()
			this.getUserInfo()
			this.getHasLocationsDay();
		}
		getUserInfo() {
			this.$request({
				method: 'get',
				url: '/bjba/yhgl/getglxx2',
				params:{userid:this.userid}
			}).then((response)=>{
				this.user = response.data.user
				this.bm =response.data.bm;
				this.gd = response.data.gd
				this.markers=[]
				this.circles=[]
				var _that = this;
				if(this.gd && this.gd.length>0) {
					for(var i=0;i<this.gd.length;i++) {
						let name = this.gd[i].gdmc;
						let x = this.gd[i].zbjd;
						let y = this.gd[i].zbwd;
						let id = this.gd[i].gdid;
						let jl = this.gd[i].dkjl;
						let rs =this.gd[i].dkrs;
						let lx =this.gd[i].gdlx;
						let morrs = this.gd[i].morrs;
						let aftrs = this.gd[i].aftrs;
						let evers = this.gd[i].evers;
						let list = {
							name: name,
							x: x,
							y: y,
							id: id,
							jl: jl,
							rs: rs,
							lx: lx,
							morrs: morrs,
							aftrs: aftrs,
							evers: evers
						};
						let marker = [x, y];
						const element = list
						const s = i
						let newmarker = {
							position: [marker],
							vid: id,
							events: {
								mouseover:(e: any) => {
									// this.form.x = e.lnglat.lng;
									// this.form.y = e.lnglat.lat;
									// console.log(_that.markers);
									_that.window.visible = false
									this.$nextTick(() => {

										_that.window.info = element
										_that.window.visible = true
										_that.window.position = [element.x, element.y]
									})
								},
								mouseout:(e:any) => {
									// this.form.x = e.lnglat.lng;
									// this.form.y = e.lnglat.lat;
									// console.log(_that.markers);
									_that.window.visible = false
									this.$nextTick(() => {

										// _that.window.info = element
										_that.window.visible = false
										// _that.window.position = [element.lng, element.lat]
									})
								}
							}
						};
						_that.markers.push(newmarker);
						let newcircle = {
							center: marker,
							radius: jl,
							fillOpacity: 0.5,
							events: {
								click: (e) => {
								}
							}
						}
						_that.circles.push(newcircle);
					}
				}
			})
		}
		getData() {
			var _that = this
			let loadingInstance1 = Loading.service({ fullscreen: true });
			this.$request({
				method: 'post',
				url: '/bjba/getLocations',
				params:{userid:this.userid,time:this.datetime}
			}).then((response)=>{
				loadingInstance1.close()
				this.markers2 =[]
				if(response.data) {
					if(response.data.length ==0 ){
						this.$message.warning(this.datetime+" 暂无轨迹")
					}
					for(var i =0; i<response.data.length;i++){

						this.dkgdmc = response.data[0].gdmc

						var array =[];
						var one = parseFloat(response.data[i].latitude);
						var two = parseFloat(response.data[i].longitude);
						array.push(two);
						array.push(one)
						if(i==0) {this.center=array;this.zoom.zoom = 24}
						this.polyline.path.push(array)
						if(i==0||i==response.data.length-1){
							let marker = array;
							let name = ''
							if (i==0) {
								var gjTime = response.data[0].time.substr(0,10)  //最后推送的位置时间
								var nowTime = this.$moment().format('YYYY-MM-DD')  //当前时间
								if (gjTime == nowTime) {
									console.log("--时间相同--")
									name = "当前位置"
								} else {
									name = "下班位置"
								}
							} else {
								name = '上班位置'
							}
							const element = {
								// name:i==0?'结束':'开始',
								name: name,
								x: marker[0],
								y: marker[1],
								id:response.data[i].id
							}
							const s = i
							let newmarker = {
								position: [marker],
								vid: element.id,
								events: {
									mouseover:(e: any) => {

										_that.window.visible = false
										this.$nextTick(() => {

											_that.window.info = element
											_that.window.visible = true
											_that.window.position = [element.x, element.y]
										})
									},
									mouseout:(e:any) => {
										// this.form.x = e.lnglat.lng;
										// this.form.y = e.lnglat.lat;
										// console.log(_that.markers);
										_that.window.visible = false
										this.$nextTick(() => {

											// _that.window.info = element
											_that.window.visible = false
											// _that.window.position = [element.lng, element.lat]
										})
									}
								}
							};
							_that.markers2.push(newmarker);
						}
					}

					console.log(this.polyline.path)
				}
			}).catch((err)=>{
				loadingInstance1.close()
				console.log(err)
			});
		}
		pageUser(page) {
			this.userCurrentPage = page
			this.getUserList()
		}
		getUserList() {
			this.loading = true
			this.$request({
				method: 'get',
				url: '/bjba/yhgl/getPageByxmOrUsername',
				params:{page:this.userCurrentPage,pagesize:2,userName:this.form.username,xm:this.form.name}
			}).then((response)=>{
				this.loading = false
					if(response.data.data) {
						this.userList = response.data.data.content;
						this.total = response.data.data.totalElements
					} else {
						this.userList = []
						this.total= 0
					}
			}).catch((err)=>{
				console.log(err)
			});
		}
		getNowFormatDate() {
			var date = new Date();
			var seperator1 = "-";
			var year = date.getFullYear();
			this.year = year;
			console.log(this.year)
			var month = date.getMonth() + 1;

			console.log(this.month)
			var strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			this.month = month;
			var currentdate = year + seperator1 + month + seperator1 + strDate;
			return currentdate;
		}
		changeDate(data) {
			if(data) {
				var time  = data.split("/")
				this.year=time[0];
				var number = parseInt(time[1]);
				if(number >=0&&number <=9) {
					this.month = "0" + time[1];
				} else  {
					this.month =time[1];
				}
				this.getHasLocationsDay()
			}
		}
		getHasLocationsDay() {
			this.$request({
				method: 'get',
				url: '/bjba/getHasLocationDay',
				params:{userid:this.userid,year:this.year,month:this.month}
			}).then((response)=>{
			console.log(response.data)
				this.arr=response.data.data
				for(var i=0;i<this.arr.length;i++) {
					var data ={date:'',className:''}
					data.date= this.arr[i];
					data.className = 'markR'
					this.arr[i] = data
				}
			}).catch((err)=>{
				console.log(err)
			});
		}
		clickDay(data) {

			if(data) {
				var date = data.split('/');
				if(parseInt(date[2]) <10) date[2]= '0'+date[2];
				if(parseInt(date[1]) <10) date[1]= '0'+date[1];
				this.datetime =date[0] + '-'+date[1]+'-' +date[2]
			}
			this.polyline.path = []
			this.getData()
		}
		selectChanged3(value) {
			this.userCurrentPage = 1;
			this.getUserList();
		}
		get gdmc() {
			if(!this.gd || this.gd.length==0) return ''
			else {
			return 	this.gd.map(function(obj,index){
					return obj.gdmc;
				}).join(",");
			}
		}

	}
